import { useSelector } from 'react-redux';

import selectors from '@/ui/flux/selectors';

function useIsLocked() {
  return useSelector(selectors.wallet.locked) ?? true;
}

export default useIsLocked;
